import { render } from "./TwoFactorAuth.vue?vue&type=template&id=21e7a052"
import script from "./TwoFactorAuth.vue?vue&type=script&lang=ts"
export * from "./TwoFactorAuth.vue?vue&type=script&lang=ts"
script.render = render

export default script